import { EventTypeEnum } from '@quadminds/shared/tracking-system';
import { ICommentDto } from './create-auditable-dto.interface';
import { AuditableStatus } from '../enums';

export interface ICreateEventDto {
    organizationId?: string;
    externalId?: string;
    event: EventTypeEnum;
    identification: Record<string, any>;
    latitude: string;
    longitude: string;
    timestamp: string;
    value?: number;
    createdBy: string;
    comments?: ICommentDto[];
    metadata?: Record<string, any>;
    vehicle?: string;
    vehicleLicensePlate?: string;
    vehicleName?: string;
    driver?: string;
    trip?: string;
    zone?: {
        id?: string;
        name?: string;
    };
}

export interface IUpdateEventDto extends Partial<ICreateEventDto> {
    status?: AuditableStatus;
    resolvedBy?: string;
    resolvedAt?: string;
}
